import ProfessionsForms from "module/AZZKUModule/components/ProfessionsForms";

export default function Step2( props ) {
   return <ProfessionsForms {...props }/>
}